import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-customer-alternative-offers-headline',
  templateUrl: './alternative-offers-headline.component.html',
})
export class BaseCustomerAlternativeOffersHeadlineComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) icon: string;
}
